import { Route, Routes } from 'react-router-dom';
import Items from './Items.js';
import Kitchen from './Kitchen.js';
import Indents from './indents.js';
import Report from './report.js';
import PurchaseOrder from './purchase-order';
import GRN from './grn/GRN.js';
import ProductionIndent from './production-indent';
import CurrentStock from './current-stock';
import GRNConsolidatedReport from './grn-consolidated-report.js';
import PIConsolidatedReport from './pi-consolidated-report.js';
import RejectedItemReport from './rejected-items-report.js';
import StockDetailsReport from './stock-details-report.js';
import UtilizationReport from './item-utilization-report.js';
import PMProductionIndent from './pm-production-indent';
import PMDeliveryChallan from './pm-delivery-challan';
import GodownItems from './godown-items';
import KitchenConsolidatedReport from './kitchen-consolidated-report';
import JWTransfer from './jw-transfer';
import JWDeliveryChallan from './jw-delivery-challan';
import JWItems from './jw-items';
import JWStockTransferReport from './jw-transfer-report';
import JWGRN from './jw-grn';
import InvJwDamage from './jw-damage/index.js';
import VendorPriceReport from './vendor-price-report';
import FinishedGoodsDetailed from './finished-goods-detailed';
import FinishedGoodsSummary from './finished-goods-summary';
import MonthWiseVendorStockReport from './monthly-vendor-price-change-report';
import ItemCategory from '../ItemCategory';
import InvDebitNote from './debit-note/index.js';

function InventoryRoutes() {
  return (
    <Routes>
      <Route path="items" element={<Items />} />
      <Route path="kitchen" element={<Kitchen />} />
      <Route path="indents" element={<Indents />} />
      <Route path="report" element={<Report />} />
      <Route path="purchase-order" element={<PurchaseOrder />} />
      <Route path="grn" element={<GRN />} />
      <Route path="jw-grn" element={<JWGRN />} />
      <Route path="jw-damage" element={<InvJwDamage />} />
      <Route path="pm-stock-transfer" element={<PMProductionIndent />} />
      <Route path="pm-delivery-challan" element={<PMDeliveryChallan />} />
      <Route path="godown-items" element={<GodownItems />} />
      <Route path="jw-transfer" element={<JWTransfer />} />
      <Route path="jw-dc" element={<JWDeliveryChallan />} />
      <Route path="jw-items" element={<JWItems />} />
      <Route path="production-indent" element={<ProductionIndent />} />
      <Route path="current-stock" element={<CurrentStock />} />
      <Route path="grn-consolidated-report" element={<GRNConsolidatedReport />} />
      <Route path="pi-consolidated-report" element={<PIConsolidatedReport />} />
      <Route path="rejected-item-report" element={<RejectedItemReport />} />
      <Route path="stock-details-report" element={<StockDetailsReport />} />
      <Route path="item-utilization-report" element={<UtilizationReport />} />
      <Route path="kitchen-consolidated-report" element={<KitchenConsolidatedReport />} />
      <Route path="jw-vendor-invoice-report" element={<JWStockTransferReport reportType="invoice-wise" />} />
      <Route path="jw-vendor-grn-report" element={<JWStockTransferReport reportType="grn-wise" />} />
      <Route path="vendor-price-report" element={<VendorPriceReport />} />
      <Route path="monthly-vendor-price-change-report" element={<MonthWiseVendorStockReport />} />
      <Route path="finished-goods-detailed" element={<FinishedGoodsDetailed />} />
      <Route path="finished-goods-summary" element={<FinishedGoodsSummary />} />
      <Route path="item-categories" element={<ItemCategory />} />
      <Route path="debit-notes" element={<InvDebitNote />} />
    </Routes>
  );
}

export default InventoryRoutes;
